import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { useGetSurveys } from 'hooks/useGetSurveys';
import { SurveyService } from 'services/surveys';
import { type DailyTrackingHistoryResponse } from 'types/chart';
import { type SurveyType } from 'types/surveys';
import { getUserId } from 'utils/storage';

export const useGetSurveyHistory = (
  surveyType: SurveyType
): UseQueryResult<DailyTrackingHistoryResponse[]> => {
  const userId = getUserId();
  const { data: surveys } = useGetSurveys(surveyType);

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_DAILY_TRACKING_HISTORY, userId, surveyType],
    queryFn: async () => {
      if (!surveys?.length) return [];
      const responses = await Promise.all(
        surveys.map(({ id }) => SurveyService.getSurveyHistory(id))
      );
      return responses.map(response => response.data);
    },
    enabled: !!userId && !!surveys?.length,
  });
};
